import { render, staticRenderFns } from "./LinkedRace.vue?vue&type=template&id=36d7c7f0&scoped=true&"
import script from "./LinkedRace.vue?vue&type=script&lang=js&"
export * from "./LinkedRace.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36d7c7f0",
  null
  
)

export default component.exports